import React from 'react';
import { bool, func, string } from 'prop-types';
import AddressFormModal from 'components/Address/common/AddressFormModal';

const addressFormModalRoutedDefaultPropOnAfterSubmit = () => {};

const AddressFormModalRouted = ({
  addAddressTitle = 'Add Address',
  editAddressTitle = 'Edit Address',
  onAfterSubmit = addressFormModalRoutedDefaultPropOnAfterSubmit,
  isEdit = false,
  manualOnly = true,
  ...props
}) => {
  const { clearNavigation, clearNavigationAction } = props;
  if (clearNavigation) {
    clearNavigationAction();
  }
  return (
    <AddressFormModal
      addAddressTitle={addAddressTitle}
      editAddressTitle={editAddressTitle}
      onAfterSubmit={onAfterSubmit}
      isEdit={isEdit}
      manualOnly={manualOnly}
      {...props}
    />
  );
};

AddressFormModalRouted.propTypes = {
  addAddressTitle: string,
  editAddressTitle: string,
  isEdit: bool,
  onCloseModal: func.isRequired,
  onAfterSubmit: func,
  isOpen: bool.isRequired,
  navigateClosed: bool.isRequired,
  clearNavigation: bool.isRequired,
  clearNavigationAction: func.isRequired,
  manualOnly: bool,
};

export default AddressFormModalRouted;
